import React from 'react';
import { Shield } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-green text-white relative overflow-hidden" data-id="element-159">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent pointer-events-none" data-id="element-160"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-brand-gold/20 blur-[100px] rounded-full pointer-events-none" data-id="element-161"></div>

      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center gap-8" data-id="element-162">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="w-44 h-44 shrink-0 bg-white rounded-full flex flex-col items-center justify-center text-brand-green shadow-2xl border-8 border-white/20" data-id="element-163">
          <Shield size={56} className="mb-1" data-id="element-164" />
          <span className="font-black text-3xl leading-none" data-id="element-165">7</span>
          <span className="font-bold uppercase tracking-widest text-sm" data-id="element-166">
            DÍAS
          </span>
        </motion.div>

        <h2 className="text-3xl sm:text-5xl font-black tracking-tight" data-id="element-167">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <p className="text-xl font-medium text-white/90" data-id="element-168">
          Abrís los tomos. Los usás. Fabricás tus primeros frasquitos.
        </p>

        <p className="text-lg leading-relaxed" data-id="element-169">
          Si en 7 días no es exactamente lo que esperabas:
          <br data-id="element-170" />
          <strong className="text-3xl block mt-3" data-id="element-171">devolución del 100%</strong>
          <span className="text-white/80 text-sm uppercase tracking-widest mt-3 block" data-id="element-172">
            sin formularios · sin drama · sin explicaciones
          </span>
        </p>

        
      </div>
    </section>;
}